import { TuiInput, TuiTextfield } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { RequestDTO } from '@core/types/Request';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  SupportManagerFullname = 'supportManagerFullname',
  SupportManagerPhone = 'supportManagerPhone',
  ClientManagerFullname = 'clientManagerFullname',
  ClientManagerPhone = 'clientManagerPhone',
  ClientManagerEmail = 'clientManagerEmail',
}

type FormType = Pick<
  RequestDTO,
  | 'supportManagerFullname'
  | 'supportManagerPhone'
  | 'clientManagerFullname'
  | 'clientManagerPhone'
  | 'clientManagerEmail'
>;

@Component({
  selector: 'x-request-form-common-managers',
  imports: [TuiTextfield, ReactiveFormsModule, TuiInput, TranslatePipe],
  templateUrl: './request-form-common-managers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonManagersComponent implements OnInit {
  protected readonly permissionService = inject(OutkeepPermissionService);
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group<FormType>({
    [FormFields.SupportManagerFullname]: '',
    [FormFields.SupportManagerPhone]: '',
    [FormFields.ClientManagerFullname]: '',
    [FormFields.ClientManagerPhone]: '',
    [FormFields.ClientManagerEmail]: '',
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('managers', this.formGroup);
  }
}
